import axios from "axios";
import { TTP_API_URL } from "Config";

export const getPages = ({ token, communityId, limit = 5 }) => {
  const requestUrl = `${TTP_API_URL}/media/hub`;

  const filter = [
    {
      property: "organization",
      value: communityId,
      operator: "eq"
    },
    {
      property: "resource",
      value: "PUBLIC_PORTAL",
      operator: "neq"
    }
  ];
  const sort = [{ property: "createdAt", dir: "DESC" }];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      limit,
      sort: JSON.stringify(sort)
    }
  });
};

export const getPublicPage = ({ token, communityId, limit = 1 }) => {
  const requestUrl = `${TTP_API_URL}/media/hub`;

  const filter = [
    {
      property: "organization",
      value: communityId,
      operator: "eq"
    },
    {
      property: "resource",
      value: "PUBLIC_PORTAL",
      operator: "eq"
    }
  ];
  const sort = [{ property: "createdAt", dir: "DESC" }];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      limit,
      sort: JSON.stringify(sort)
    }
  });
};

export const savePage = ({
  token,
  communityId,
  id,
  title,
  language,
  subtitle,
  resource,
  filters = [],
  template,
  subdomain,
  details
}) => {
  const requestUrl = `${TTP_API_URL}/media/hub`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("organization_id", communityId);
  formData.append("organization", communityId);

  if (id) {
    formData.append("id", id);
  }

  formData.append("title", title);
  formData.append("subtitle", subtitle);
  formData.append("language", language);
  formData.append("resource", resource);
  formData.append("template", template);
  formData.append("subdomain", subdomain);
  formData.append("filters", JSON.stringify(filters));
  formData.append("details", JSON.stringify(details));

  return axios.post(requestUrl, formData);
};

export const deletePage = ({ token, pageId }) => {
  const requestUrl = `${TTP_API_URL}/media/hub/${pageId}`;

  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/page.js